<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="flex flex-col w-full justify-center">
            <page-callout section="kiosk-team-historical-invoices" class="mb-4" />

            <team-historical-invoices :teamId="team.id" />
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from '~/components/kiosk/kiosk-teams/details/KioskTeamDetails.vue';
import { useTeamDetails } from '~/components/kiosk/kiosk-teams/composables/useTeamDetails';
import PageCallout from '~/components/general/PageCallout.vue';
import TeamHistoricalInvoices from '~/components/settings/billing/TeamHistoricalInvoices.vue';

const { team } = useTeamDetails();

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});
</script>
